import { render } from "./Docusign.vue?vue&type=template&id=65f1b25b&scoped=true&ts=true&lang=pug"
import script from "./Docusign.vue?vue&type=script&lang=ts&setup=true"
export * from "./Docusign.vue?vue&type=script&lang=ts&setup=true"

import "./Docusign.vue?vue&type=style&index=0&id=65f1b25b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f1b25b"]])

export default __exports__